import React from "react";
import { makeStyles } from "@mui/styles";
import { useLocation } from "react-router-dom";

import { Header as UCoreHeader } from "./Header/";
import HeaderBrandLogo from "./Header/HeaderBrandLogo";
import HeaderLinkText from "./Header/HeaderLinkText";
import LogoMt from "../../images/mt-partner-truck.png";

const useStyles = makeStyles((theme) => ({
  container: {
    background: "linear-gradient(135deg, rgba(12, 84, 112, 0.95) 0%, rgba(66, 139, 202, 0.95) 100%)",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",
    borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
    position: "relative",
    
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "linear-gradient(135deg, var(--primary-main) 0%, var(--secondary-main) 100%)",
      opacity: 0.9,
      zIndex: -1,
    },

    "& p, a, span, div": {
      fontFamily: "'Inter', sans-serif",
      textTransform: "uppercase",
      fontWeight: 500,
      fontSize: "15px",
      letterSpacing: "0.5px",
      color: "white",
      transition: "all 0.3s ease-in-out",
    },
    
    "& img": {
      height: "65px",
      left: "50px",
      filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2))",
      transition: "transform 0.3s ease-in-out",
      
      "&:hover": {
        transform: "scale(1.05)",
      },
    },
  },
  
  active: {
    color: "var(--accent-teal) !important",
    fontWeight: "600 !important",
    textShadow: "0 0 10px rgba(32, 201, 151, 0.3)",
    transform: "translateY(-1px)",
    
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: "-8px",
      left: "50%",
      transform: "translateX(-50%)",
      width: "60%",
      height: "2px",
      background: "linear-gradient(90deg, transparent, var(--accent-teal), transparent)",
      borderRadius: "2px",
    },
  },
  
  link: {
    position: "relative",
    marginTop: "28px",
    marginBottom: "28px",
    padding: "8px 16px",
    borderRadius: "8px",
    transition: "all 0.3s ease-in-out",
    
    "&:hover": {
      background: "rgba(255, 255, 255, 0.1)",
      transform: "translateY(-2px)",
      textShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
      
      "&:not(.active)": {
        color: "var(--accent-teal) !important",
      },
    },
    
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "linear-gradient(45deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05))",
      borderRadius: "8px",
      opacity: 0,
      transition: "opacity 0.3s ease-in-out",
    },
    
    "&:hover::before": {
      opacity: 1,
    },
  },

  "@media screen and (max-width: 1084px)": {
    widget: {
      marginLeft: "35px",
    },
    active: {
      color: "var(--accent-teal) !important",
    },
    container: {
      "& p, a, span, div": {
        fontSize: "14px",
      },
    },
  },
  
  logo: {
    width: "100%",
    transition: "transform 0.3s ease-in-out",
    
    "&:hover": {
      transform: "scale(1.02)",
    },
  },

  "@media screen and (max-width: 600px)": {
    container: {
      "& .UCoreToolbar-regular": {
        minHeight: "70px",
      },
      
      "& img": {
        height: "55px",
      },
      
      "& p, a, span, div": {
        fontSize: "13px",
      },
    },
    
    link: {
      padding: "6px 10px",
      marginTop: "24px",
      marginBottom: "24px",
    },
  },
  
  "@media screen and (max-width: 480px)": {
    container: {
      "& img": {
        height: "45px",
      },
      
      "& p, a, span, div": {
        fontSize: "12px",
        letterSpacing: "0.3px",
      },
    },
  },
}));

const Header = () => {
  const classes = useStyles();
  const location = useLocation();

  return (
    <div className={classes.container}>
      <UCoreHeader menuWidth={1100}>
        <HeaderBrandLogo logo={LogoMt} to="/" showWhenCollapsed />
        <HeaderLinkText
          text="Home"
          to="/"
          right
          exact
          linkClassName={[
            location.pathname === "/" ? classes.active : "",
            classes.link,
          ].join(" ")}
        />
        <HeaderLinkText
          text="Diensten"
          to="/services"
          right
          exact
          linkClassName={[
            location.pathname === "/services" ? classes.active : "",
            classes.link,
          ].join(" ")}
        />
        <HeaderLinkText
          text="Over ons"
          to="/about-us"
          right
          exact
          linkClassName={[
            location.pathname === "/about-us" ? classes.active : "",
            classes.link,
          ].join(" ")}
        />
        <HeaderLinkText
          text="Contact"
          to="/contact"
          right
          exact
          linkClassName={[
            location.pathname === "/contact" ? classes.active : "",
            classes.link,
          ].join(" ")}
        />
      </UCoreHeader>
    </div>
  );
};

Header.displayName = "Header";

export default Header;
